// extracted by mini-css-extract-plugin
export var checked = "Checkbox_checked__h2qW4";
export var chooseManyCheckbox = "Checkbox_chooseManyCheckbox__M1ucx";
export var chooseManyCheckmark = "Checkbox_chooseManyCheckmark__0G4Gn";
export var disabled = "Checkbox_disabled__tDTQK";
export var md = "768px";
export var shared = "\"../../../shared.module.css\"";